/** Measures the widest line of a text value with canvas metrics; estimates without a DOM. */
export function measureTextWidth(value: string, family: string, weight: number, size: number, tracking: number): number {
  if (typeof document === 'undefined') {
    const longest = Math.max(...value.split('\n').map((line) => line.length), 0);
    return Math.ceil(longest * size * 0.6 + tracking * Math.max(0, longest - 1));
  }
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');
  if (!context) return Math.ceil(value.length * size * 0.6);
  context.font = `${String(weight)} ${String(size)}px ${family}`;
  let max = 0;
  for (const line of value.split('\n')) {
    max = Math.max(max, context.measureText(line).width + tracking * Math.max(0, line.length - 1));
  }
  return Math.ceil(max);
}
